module.exports = __webpack_public_path__ + "img/header-weddingRingsPlain.6bce9dd.webp";